<template>
    <section class="technology-lab content-section" ref="ad">
        <b-container fluid>
            <b-row class="mb-5">
                <b-col lg="12">
                    <h2 class="technology-ad-title text-center">Keeping the laboratory equipments up with the times, <br> and processing every production step strictly is the top priority we do.</h2>
                </b-col>
            </b-row>
            <b-row class="justify-content-center">
                <b-col v-for="(item, index) in 5" :key="index" class="text-center technology-ad-icon-wrap">
                    <b-img :src="require(`@/assets/images/lab/eq/ad-0${index+1}.png`)" />
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
           
        }
    },
}
</script>

<style lang="scss">
    .technology-lab {
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-image: url('~@/assets/images/lab/bg.jpg');
        border-top:2px solid rgb(221, 221, 221);
        border-bottom:2px solid rgb(221, 221, 221);
    }
    .technology-ad-title{
        color: $color-main-aux
    }
    .technology-ad-icon-wrap{
        flex: 0 0;
        padding: 0 50px
    }
</style>